<template>
  <div class="container">
    <hr class="space space-sm">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h3 class="text-center mb-4" v-if="hike">{{ hike ? 'Редактировать поход' : 'Добавить поход' }}</h3>
        

        <div class="row" v-if="!hike">
          <div class="col-12 text-center my-4">
            <h2>Создание похода - просто и быстро</h2>
            <p>Добавьте прошедший поход или <strong>создайте новый</strong> и пригласите друзей!</p>
          </div>
        </div>

        <loader v-if="isLoading"></loader>
        <b-form v-else @submit="onSubmit" @reset="onReset" ref="form">
          <!-- Wizard navigation -->
          <div v-show="step !== 1 && !isEditing" class="d-flex justify-content-between mb-4 align-items-center">
            <b-button @click="previous" :disabled="step === 1" variant="light">Назад</b-button>
            <span>Шаг {{ step }} из 5</span>
            <b-button @click="next" :disabled="step === 5" variant="light">Вперед</b-button>
          </div>
          <!-- Step 1: Basic Information -->
          <div v-show="step === 1">
            <div class="row mb-3" v-if="!hike">
              <div class="col-md-4">
                <div class="card match_height">
                  <div class="card-body">
                    <h4 class="card-title"><img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/hiking.png" alt=""></h4>
                    <h5 class="card-subtitle mb-2">1. Расскажите о маршруте</h5>
                    <p class="card-text">Поделитесь основной информацией, такой как местоположение, дата и время.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card match_height">
                  <div class="card-body">
                    <h4 class="card-title"><img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/outdoor.png" alt=""></h4>
                    <h5 class="card-subtitle mb-2">2. Сделайте его привлекательным</h5>
                    <p class="card-text">Добавьте название, описание, сложность и GPS-трек.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card match_height">
                  <div class="card-body">
                    <h4 class="card-title"><img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/route.png" alt=""></h4>
                    <h5 class="card-subtitle mb-2">3. Завершите и опубликуйте</h5>
                    <p class="card-text">Опубликуйте и поделитесь ссылкой с друзьями.</p>
                    <b-button @click="next" :disabled="step === 5" variant="primary" block>Начать</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="step === 2 || isEditing">
            <b-form-group label="🏔️ Название" label-for="title">
              <b-form-input id="title"
                type="text"
                placeholder="Придумайте название для похода"
                v-model="form.title"
                required>
              </b-form-input>
            </b-form-group>

            <b-form-group label="Описание" label-for="description">
              <b-form-textarea id="description"
                type="text"
                placeholder="Опишите поход и его маршрут в нескольких предложениях"
                rows="5"
                v-model="form.description">
              </b-form-textarea>
            </b-form-group>
            <div v-if="form.photos && form.photos.length > 0">
              <div class="row">
                <div class="col-md-12">
                  <h5>Фотографии</h5>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <b-card-group deck>
                    <b-card v-for="(photo, index) in form.photos" :key="index" :img-src="photo.url" img-alt="Image" img-top>
                      <b-button size="sm" variant="danger" @click="deletePhoto(index)">Удалить</b-button>
                    </b-card>
                  </b-card-group>
                </div>
              </div>
            </div>
            <b-form-group label="Загрузить фотографии" label-for="photos">
              <b-form-file id="photos"
                ref="photosInput"
                placeholder="Выберите фотографии"
                multiple
                accept="image/*">
              </b-form-file>
            </b-form-group>
            <b-form-group label="YouTube" label-for="city" v-if="user && user.isAdmin">
              <b-form-input id="youtubeURL"
                type="text"
                placeholder="Ссылка на видео с YouTube"
                v-model="form.youtubeURL"
                required>
              </b-form-input>
            </b-form-group>
          </div>

          <div v-show="step === 3 || isEditing" class="row">
            <div class="col-md-6">
              <b-form-group label="Место старта" label-for="location">
                <b-form-input id="location"
                  type="text"
                  placeholder="Остановка, место сбора"
                  v-model="form.location">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Город" label-for="city">
                <b-form-input id="city"
                  type="text"
                  v-model="form.city"
                  required>
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Страна" label-for="country">
                <b-form-select id="country"
                  v-model="form.country"
                  :options="countryList"
                  required>
                </b-form-select>
              </b-form-group>
            </div>
          </div>

          <!-- <b-form-group label="Конец" label-for="endDate">
            <b-form-input id="endDate"
              type="date"
              v-model="form.endDate"
              required>
            </b-form-input>
          </b-form-group>
          <b-form-group label="Время окончания" label-for="endTime">
            <b-form-input id="endTime"
              type="time"
              v-model="form.endTime"
              required>
            </b-form-input>
          </b-form-group> -->

          <!-- Step 3: Hike Details -->
          <div v-show="step === 4 || isEditing" class="row">
            <div class="col-md-6">
              <b-form-group label="Сложность (от 1 до 5)" label-for="difficulty">
                <b-form-input id="difficulty"
                  v-model="form.difficulty"
                  type="range" min="1" max="5"
                  step="1"
                  tooltip="always">
                </b-form-input>
                <div class="mt-3">
                  <span v-if="form.difficulty === '1'" title="Легко">🏔️ Легко</span>
                  <span v-if="form.difficulty === '2'" title="Средне">🏔️🏔️ Средне</span>
                  <span v-if="form.difficulty === '3'" title="Сложно">🏔️🏔️🏔️ Сложно</span>
                  <span v-if="form.difficulty === '4'" title="Очень сложно">🏔️🏔️🏔️🏔️ Очень сложно</span>
                  <span v-if="form.difficulty === '5'" title="Чрезвычайно сложно">🏔️🏔️🏔️🏔️🏔️ Чрезвычайно сложно</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="GPS трек" label-for="gpsTrack">
                <b-form-file id="gpsTrack"
                  v-model="gpsTrack"
                  :state="Boolean(gpsTrack)"
                  accept=".gpx,.kml,.kmz"
                  placeholder="Выберите файл">
                </b-form-file>
              </b-form-group>
              <div v-if="form.gpsTrackURL" class="row mt-2">
                <div class="col-md-6">
                  <b-button variant="danger" size="sm" @click="deleteGpsTrack">
                    Удалить GPS трек
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          
          <div v-show="step === 5 || isEditing">
            <div class="row mb-3">
              <div class="col-md-6 my-3">
                <label for="startDate">Дата и время похода</label>
                <div class="d-flex">
                  <b-form-input id="startDate"
                    type="date"
                    v-model="form.startDate"
                    required>
                  </b-form-input>
                  <b-form-input id="startTime"
                    type="time"
                    v-model="form.startTime">
                  </b-form-input>
                </div>
              </div>
              <div class="col-md-6 my-3">
                <label for="durationHours">Продолжительность похода</label>
                <div class="d-flex">
                  <b-form-input id="durationHours"
                    type="number"
                    v-model="form.durationHours"
                    placeholder="Часов">
                  </b-form-input>
                  <b-form-input id="durationMinutes"
                    type="number"
                    v-model="form.durationMinutes"
                    placeholder="Минут">
                  </b-form-input>
                  <!-- <b-form-input id="durationSeconds"
                    type="number"
                    v-model="form.durationSeconds"
                    placeholder="Секунд">
                  </b-form-input> -->
                </div>
              </div>

              <div class="col-md-6">
                <b-form-group label="Набор высоты" label-for="elevation">
                  <b-form-input id="elevation"
                    type="number"
                    placeholder="Сколько метров"
                    v-model="form.elevation">
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <label for="distance">Дистанция</label>
                <div class="d-flex">
                  <b-form-input id="distance"
                    type="number"
                    step="any"
                    v-model="form.distance">
                  </b-form-input>
                  <b-form-select id="distanceUnit"
                    v-model="form.distanceUnit"
                    :options="distanceUnits">
                  </b-form-select>
                </div>
              </div>
              <!-- <div class="col-md-4">
                <b-form-group label="Конфиденциальность" label-for="privacy">
                  <b-form-select id="privacy"
                    v-model="form.privacy"
                    :options="privacyOptions">
                  </b-form-select>
                </b-form-group>
              </div> -->
            </div>
            <b-button type="submit" variant="primary">Сохранить</b-button>
            <router-link :to="{ name: 'hikes' }" class="btn btn-light">Отмена</router-link>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'hike-create',
  data () {
    return {
      form: {
        title: '',
        location: '',
        distance: '',
        distanceUnit: 'kilometers',
        elevation: '',
        difficulty: '3',
        description: '',
        submittedBy: this.$store.state.auth.user.id,
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        privacy: 'public',
        dateTime: new Date().toISOString(),
        author: this.$store.state.auth.user.name,
        durationHours: '',
        durationMinutes: '',
        durationSeconds: '',
        city: '',
        country: 'kazakhstan',
        gpsTrackURL: '',
        gpsTrackName: '',
        youtubeURL: '',
        photos: []
      },
      gpsTrack: null,
      distanceUnits: [
        { text: 'км', value: 'kilometers' },
        { text: 'м', value: 'meters' }
      ],
      privacyOptions: ['public', 'followers', 'everyone'],
      isLoading: null,
      countryList: [
        { text: 'Казахстан', value: 'kazakhstan' },
        { text: 'Кыргызстан', value: 'kyrgyzstan' },
        { text: 'Россия', value: 'russia' },
        { text: 'Украина', value: 'ukraine' },
        { text: 'Беларусь', value: 'belarus' },
        { text: 'Грузия', value: 'georgia' },
        { text: 'Узбекистан', value: 'uzbekistan' },
        { text: 'Другая', value: 'other' }
      ],
      step: 1
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      hike: state => state.hikes.hike
    }),
    isEditing () {
      return this.hike !== null
    }
  },
  methods: {
    setCardsHeight () {
      const cards = document.querySelectorAll('.match_height')
      const maxHeight = Math.max(...Array.from(cards).map(card => card.clientHeight))
      cards.forEach(card => {
        card.style.height = `${maxHeight}px`
      })
    },
    next () {
      if (this.step < 5) {
        this.step++
      }
    },
    previous () {
      if (this.step > 1) {
        this.step--
      }
    },
    deletePhoto (index) {
      this.form.photos.splice(index, 1)
    },
    async onSubmit (evt) {
      evt.preventDefault()
      this.isLoading = true

      try {
        await this.uploadPhotos()
        if (this.gpsTrack) {
          await this.$store
            .dispatch('UPLOAD_GPS_TRACK', {
              file: this.gpsTrack,
              userId: this.$store.state.auth.user.id
            })
            .then((fileURL) => {
              this.form.gpsTrackURL = fileURL
              this.form.gpsTrackName = this.gpsTrack.name

              if (this.$route.params.id) {
                this.form.author = this.$store.state.auth.user.name
                return this.$store.dispatch('UPDATE_HIKE', {
                  data: this.form,
                  id: this.$route.params.id
                })
              } else {
                this.form.createdAt = new Date().toISOString()
                return this.$store.dispatch('CREATE_HIKE', this.form)
              }
            })
        } else {
          if (this.$route.params.id) {
            this.form.author = this.$store.state.auth.user.name
            await this.$store.dispatch('UPDATE_HIKE', {
              data: this.form,
              id: this.$route.params.id
            })
          } else {
            this.form.createdAt = new Date().toISOString()
            await this.$store.dispatch('CREATE_HIKE', this.form)
          }
        }

        this.isLoading = false
        this.$router.push({ name: 'hikes' })
      } catch (error) {
        this.isLoading = false
        console.error('Error submitting the form:', error)
      }
    },
    async uploadPhotos () {
      if (!this.$refs.photosInput) {
        console.error('photosInput is not defined')
        return
      }
      const files = Array.from(this.$refs.photosInput.files)
      const userId = this.$store.state.auth.user.id

      try {
        // Use Promise.all to upload all files concurrently
        const photos = await Promise.all(
          files.map(async (file) => {
            const fileURL = await this.$store.dispatch('UPLOAD_PHOTO', { file, userId })
            return {
              url: fileURL,
              name: file.name
            }
          })
        )

        // create field photos if it doesn't exist and contact it with uploaded photos
        if (!this.form.photos) {
          this.form.photos = photos
        } else {
          this.form.photos = this.form.photos.concat(photos)
        }
      } catch (error) {
        console.error('Error uploading photos:', error)
      }
    },
    onReset (evt) {
      evt.preventDefault()
      this.form = {
        title: '',
        location: '',
        distance: '',
        distanceUnit: 'kilometers',
        elevation: '',
        difficulty: '3',
        description: '',
        submittedBy: this.$store.state.auth.user.id,
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        privacy: 'public',
        dateTime: new Date().toISOString(),
        author: this.$store.state.auth.user.name,
        durationHours: '',
        durationMinutes: '',
        durationSeconds: '',
        city: '',
        country: '',
        gpsTrackURL: '',
        gpsTrackName: '',
        youtubeURL: '',
        photos: []
      }
      this.gpsTrack = null
    },
    async deleteGpsTrack () {
      try {
        // First, delete the GPS track
        await this.$store.dispatch('DELETE_GPS_TRACK', {
          gpsTrackName: this.form.gpsTrackName,
          userId: this.$store.state.auth.user.id
        })

        // If GPS track deletion is successful, update the hike information
        const newForm = {
          gpsTrackURL: '',
          gpsTrackName: ''
        }

        this.form.gpsTrackName = ''
        this.form.gpsTrackURL = ''

        await this.$store.dispatch('UPDATE_HIKE', {
          data: newForm,
          id: this.$route.params.id
        })
      } catch (error) {
        console.error('Error deleting the GPS track:', error)
      }
    },
    // Add this helper method to request a new file from the user
    requestNewFile () {
      return new Promise((resolve) => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = '.gpx,.kml,.kmz'

        input.addEventListener('change', (event) => {
          resolve(event.target.files[0])
        })

        input.click()
      })
    }
  },
  mounted () {
    this.setCardsHeight()
  },
  created () {
    if (this.$route.params.id) {
      this.isLoading = true
      this.$store.dispatch('GET_HIKE', this.$route.params.id).then(() => {
        this.isLoading = false
        this.form = this.$store.state.hikes.hike
      })
    } else {
      this.$store.commit('SET_LOADED_HIKE', null)
    }
  }
}
</script>